import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { twMerge } from 'tailwind-merge';

type Props = {
  url: string;
  text: string;
  containerClassName?: string;
};

export const ExternalLink = (props: Props) => {
  return (
    <div className={twMerge('flex items-center', props.containerClassName)}>
      <OpenInNewIcon className="text-primary mr-2" />
      <a
        href={props.url}
        target="_blank"
        className="text-primary font-semibold no-underline"
      >
        {props.text}
      </a>
    </div>
  );
};
